import styled from '@emotion/styled';
import React from 'react';

const Div = styled.div`
  height: 64px;
  width: 64px;
`;
export const Sparnadur = () => (
  <Div>
    <object type="image/svg+xml" data="/svgs/Sparnadur.svg" tabIndex={-1}>
      Sparnaður
    </object>
  </Div>
);
